import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmptyStar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.8085 8.87488L19.6485 9.29488C20.5285 9.36488 20.8785 10.4649 20.2085 11.0449L16.5385 14.2249L17.6385 18.9549C17.8385 19.8149 16.9085 20.4949 16.1485 20.0349L11.9985 17.5249L7.84854 20.0249C7.08854 20.4849 6.15854 19.8049 6.35854 18.9449L7.45854 14.2249L3.78854 11.0449C3.11854 10.4649 3.47854 9.36488 4.35854 9.29488L9.18854 8.88488L11.0785 4.42488C11.4185 3.61488 12.5785 3.61488 12.9185 4.42488L14.8085 8.87488ZM8.23854 17.9249L11.9985 15.6549L15.7685 17.9349L14.7685 13.6549L18.0885 10.7749L13.7085 10.3949L11.9985 6.35488L10.2985 10.3849L5.91854 10.7649L9.23854 13.6449L8.23854 17.9249Z",
		fill: "currentColor"
	})
});
export default SvgEmptyStar;
